import React, { useEffect } from 'react';
import { useCurrentUserQuery } from 'api';
import { Col, Layout, Row } from 'components';
import { ADMIN_ROUTES } from 'constants/routes';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';
import { useAuth } from '../../../../hooks/useAuth';

export const AppLayout = React.memo(() => {
  useAuth();
  const userId = JSON.parse(localStorage.getItem('userId') || 'null');
  const location = useLocation();
  const navigate = useNavigate();
  const { data = {}, isLoading } = useCurrentUserQuery({ userId }, { skip: !userId });

  useEffect(() => {
    if (data?.id && location.pathname === ADMIN_ROUTES.adminSignIn) {
      navigate(`${ADMIN_ROUTES.dashboardPage}/list`);
    }
  }, [data, location.pathname, navigate]);

  return (
    <Layout className={styles.layout}>
      <Row className={styles.web_layout}>
        <Col span={24}>{!isLoading && <Outlet />}</Col>
      </Row>
    </Layout>
  );
});
